import { BaseService } from '../../../shared/Services/BaseService';
import { authenticationService } from '../../../shared/Services/authenticationService';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ServicesService extends BaseService {
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    const baseUrl = environment.apiUrl + 'Service';

    super(http, authenticationSerives, baseUrl);
  }
}
